import { render } from "./douyinPath.vue?vue&type=template&id=6433246f"
import script from "./douyinPath.vue?vue&type=script&lang=js"
export * from "./douyinPath.vue?vue&type=script&lang=js"

import "./douyinPath.vue?vue&type=style&index=0&id=6433246f&lang=css"

import exportComponent from "/root/workspace/cinema-admin_TXA8/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__